import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n'; // Initialize i18n for internationalization
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Suppress noisy unhandled promise rejections in production (e.g., blocked network requests)
if (process.env.NODE_ENV === 'production') {
  try {
    window.addEventListener('unhandledrejection', (event) => {
      event.preventDefault();
      // no console output in production
    });
  } catch { }
}

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
